import { Grid, Stack, Typography } from '@mui/material'

import { CardSelectorCardType } from './CardSelectorCardType'

import CardTypeChip from '@/components/CardTypeChip'
import {
  CardActivityType,
  MULTIPLE_CHOICE_CARD_ACTIVITY_TYPES,
  REPEAT_CARD_ACTIVITY_TYPES,
  RESPOND_CARD_AUDIO_ACTIVITY_TYPES,
  RESPOND_CARD_WRITTEN_ACTIVITY_TYPES,
  SHORT_ANSWER_CARD_ACTIVITY_TYPES,
} from '@/models/card-activity/card-activity.model'
import { CARD_ICONS_BG } from '@/constants/card-icons.constants'
import { bulkImportStoreActions } from '@/components/BulkImportModal/store/bulk-import.store'
import { type AllowedCardTypesBulkImport } from '@/components/BulkImportModal/store/bulk-import.store.types'
import { useBulkImportStore } from '@/components/BulkImportModal/hooks/useBulkImportStore'

const cards = [
  {
    title: 'Spoken Open Response',
    // description: 'Students record their response to your prompt. Review, score, and provide feedback on responses in the gradebook.',
    icon: <CardTypeChip iconOnly size="medium" type={CardActivityType.RESPOND} />,
    bgcolor: CARD_ICONS_BG.RespondCardSpoken,
    type: CardActivityType.READ_RESPOND,
    associatedTypes: RESPOND_CARD_AUDIO_ACTIVITY_TYPES,
  },
  {
    title: 'Written Open Response',
    // description: 'Students type a response to your prompt. Review, score, and provide feedback on responses in the gradebook.',
    icon: <CardTypeChip iconOnly size="medium" type={CardActivityType.RESPOND_WRITE} />,
    bgcolor: CARD_ICONS_BG.RespondCardWritten,
    type: CardActivityType.RESPOND_WRITE,
    associatedTypes: RESPOND_CARD_WRITTEN_ACTIVITY_TYPES,
  },
  {
    title: 'Short Answer',
    // description: 'Students type a response to your prompt. Review, score, and provide feedback on responses in the gradebook.',
    icon: <CardTypeChip iconOnly size="medium" type={CardActivityType.SHORT_ANSWER} />,
    bgcolor: CARD_ICONS_BG.RespondCardWritten,
    type: CardActivityType.SHORT_ANSWER,
    associatedTypes: SHORT_ANSWER_CARD_ACTIVITY_TYPES,
  },

  {
    title: 'Listen & Repeat',
    // description: "Students listen to a model word, phrase, or sentence and repeat it. Their response is transcribed and compared to the teacher's input.",
    icon: <CardTypeChip iconOnly size="medium" type={CardActivityType.REPEAT} />,
    bgcolor: CARD_ICONS_BG.RepeatCard,
    type: CardActivityType.READ_REPEAT,
    associatedTypes: REPEAT_CARD_ACTIVITY_TYPES,
  },
  {
    title: 'Multiple Choice',
    // description: 'Students select the correct answer from a list of options. Responses are auto-graded based on the correct answer you provide.',
    icon: <CardTypeChip iconOnly size="medium" type={CardActivityType.MULTIPLE_CHOICE} />,
    bgcolor: CARD_ICONS_BG.MCCard,
    type: CardActivityType.MULTIPLE_CHOICE,
    associatedTypes: MULTIPLE_CHOICE_CARD_ACTIVITY_TYPES,
  },
]

export function FirstStepBulkImport() {
  const cardTypeSeleted = useBulkImportStore(store => store.cardType)

  return (
    <Stack
      sx={{
        display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        flexDirection: 'column',
        gap: '12px',
        padding: '20px',
        maxWidth: '600px',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Stack>
        <Typography fontSize="12px" fontWeight="400" color="primary.dark">
          Step 1
        </Typography>
        <Typography fontSize="16px" fontWeight="600">
          Select Page Type
        </Typography>
      </Stack>
      <Grid container spacing={1} sx={{ width: '100%' }}>
        {cards.map((card) => (
          <Grid item xs={12} key={card.title}>
            <CardSelectorCardType
              card={card}
              selected={cardTypeSeleted === card.type}
              onClick={() => {
                bulkImportStoreActions.updateImportBulkStore({
                  cardType: card.type,
                })
                bulkImportStoreActions.handleNextStep()
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}
